export default __webpack_public_path__ + "./image/7b0503531707c6654e1e1c54b38b4fd6.png";